/** CSVエクスポート（仕様書 §14）。 */

import type { Category, ProjectsDoc } from '../domain/types';
import { findProject } from '../db/projects';
import type { EntryRecord } from '../db/schema';
import { UNCATEGORIZED_LABEL } from '../db/categories';

const HEADERS = [
  '日時',
  'プロジェクト',
  'カテゴリ',
  'タイトル',
  '本文',
  '緯度',
  '経度',
  '画像ファイル名',
];

/** RFC 4180。全フィールドをダブルクォートで囲み、値中の " は "" にする。 */
function quote(v: string): string {
  return `"${v.replace(/"/g, '""')}"`;
}

function categoryName(map: Map<string, Category>, id: string | null): string {
  if (!id) return UNCATEGORIZED_LABEL;
  const c = map.get(id);
  return c && !c.deleted ? c.name : UNCATEGORIZED_LABEL;
}

export function buildCsv(
  entries: EntryRecord[],
  categories: Map<string, Category>,
  projects?: ProjectsDoc,
): string {
  const rows = [HEADERS.map(quote).join(',')];

  // date 昇順
  const sorted = [...entries].sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));

  for (const e of sorted) {
    rows.push(
      [
        // "2026-08-26 14:30"
        `${e.date.slice(0, 10)} ${e.date.slice(11, 16)}`,
        (projects && findProject(projects, e.projectId)?.name) ?? '',
        categoryName(categories, e.categoryId),
        e.title,
        e.body,
        e.location ? e.location.lat.toFixed(6) : '',
        e.location ? e.location.lng.toFixed(6) : '',
        e.media.map((m) => m.file).join('|'),
      ]
        .map(quote)
        .join(','),
    );
  }
  // 改行は CRLF
  return rows.join('\r\n') + '\r\n';
}

export function csvFileName(entries: EntryRecord[]): string {
  if (entries.length === 0) return 'journal.csv';
  const dates = entries.map((e) => e.dateKey).sort();
  const from = dates[0].replace(/-/g, '');
  const to = dates[dates.length - 1].replace(/-/g, '');
  return `journal_${from}-${to}.csv`;
}

/** UTF-8 BOM 付きでダウンロードさせる（日本語WindowsのExcelでの文字化け防止）。 */
export function downloadCsv(csv: string, fileName: string): void {
  const BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([BOM, csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
